<div class="cmp-container learnspace-theme">
    <page-header *ngIf="course" [title]="course.title" [backgroundUrl]="course?.postermedia?.path" [additionalActions]="pageHeaderAdditionalActions" ></page-header>
    <div class="page-container" *ngIf="course" >
      <mat-tab-group vertical [hidden]="displayLogSessionId" [selectedIndex]="getSelectedIndex()" (selectedIndexChange)="onSelectedIndexChange($event)" >
        <mat-tab label="Overview" color="white" class="learnspace-theme">
          <ng-template matTabContent>
            <course-stats [course]="course" [quizzes]="quizzes" [date_from]="date_from" [date_to]="date_to" (navigateTab)="onNavigateTab($event)"></course-stats>
          </ng-template>
        </mat-tab>
        <mat-tab color="white" class="learnspace-theme">
          <ng-template mat-tab-label>
            AI Assessment
            <span class="tab-name-tag">New</span>
          </ng-template>
          <ng-template matTabContent>
            <assessment [course]="course" [date_from]="date_from" [date_to]="date_to" (onExplore)="displayLog($event)"></assessment>
          </ng-template>
        </mat-tab>
        <mat-tab label="Visitors" color="white" class="learnspace-theme">
          <ng-template matTabContent>
            <visitors-stats [course]="course" [date_from]="date_from" [date_to]="date_to" [search]="activeUserSearch"  (onSearch)="onNavigateTab($event)"></visitors-stats>
          </ng-template>
        </mat-tab>
        <mat-tab label="Contents" color="white" class="learnspace-theme" *ngIf="!isAIExperience">
          <ng-template matTabContent>
            <content-stats [experienceId]="course.id" [date_from]="date_from" [date_to]="date_to"></content-stats>
          </ng-template>
        </mat-tab>
        <mat-tab label="Sessions" color="white" class="learnspace-theme">
          <ng-template matTabContent>
            <session-list [course]="course" [date_from]="date_from" [date_to]="date_to" [search]="activeUserSearch" (onExplore)="displayLog($event)"  (onSearch)="onNavigateTab($event)"></session-list>
          </ng-template>
        </mat-tab>
        <mat-tab label="Quizzes" color="white" class="learnspace-theme" *ngIf="!isAIExperience">
          <ng-template matTabContent>
            <quiz-results [quizzes]="quizzes" [date_from]="date_from" [date_to]="date_to" [search]="activeUserSearch"  (onSearch)="onNavigateTab($event)"></quiz-results>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      <div *ngIf="displayLogSessionId" class="session-log">
        <xapi-log [sessionId]="displayLogSessionId" (onGoBack)="displaySessions()"></xapi-log>
      </div>
     
    </div>
</div>

